import * as journal from "@client/features/journal";
import * as forms from "@client/forms";
import {FormShell} from "@client/forms";
import * as router from "@client/router";
import {server} from "@reactivated";
import * as React from "react";

export const UpdateMeasurements = router.UpdateMeasurements.withHooks((props) => {
    const measurement = props.resolved.journal.day.measurements[0];

    return {
        form: forms.useForm(server.journal.day.MeasurementForm, {
            initial: measurement,
        }),
    };
})
    .withIndex((props) => {
        React.useEffect(() => {
            setTimeout(() => {
                (document.querySelector(".label input") as HTMLInputElement).focus();
            }, 500);
        }, []);

        const measurements = props.profile.user.get_measurements;

        return (
            <>
                {props.profile.user.email === "maryzaida@hotmail.com" && (
                    <div
                        style={{
                            fontSize: "2rem",
                            textAlign: "center",
                            margin: "1rem 0",
                        }}
                    >
                        Ma, medir la cintura.
                        <br />
                        Chop chop.
                        <br />
                        ❤️
                    </div>
                )}
                <FormShell>
                    {measurements.map((name) => (
                        <forms.Field key={name} field={props.form.fields[name]} />
                    ))}
                </FormShell>
            </>
        );
    })
    .withActions((props) => [
        {
            icon: "save",
            title: "Save",
            onClick: () =>
                props.dispatch(
                    journal.updateMeasurements(props.resolved.journal, props.form),
                ),
        },
    ])
    .withOptions(() => ({
        isDelegatable: true,
        title: "Measurements",
        back: "Journal",
        scene: {kind: "SIMPLE"},
    }));
